// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BDFIFHVM1uRktH456BNX{display:flex;align-items:center;gap:9px;width:100%;margin-top:-3px}.ty_WLxO50RmaYZjONQ5F{flex:1}`, "",{"version":3,"sources":["webpack://./src/pages/settings/pages/addOns/ui/BrandedUrlShortener/ModalActions/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,kBAAA,CACA,OAAA,CACA,UAAA,CACA,eAAA,CAGF,sBACE,MAAA","sourcesContent":[".actions {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  width: 100%;\n  margin-top: -3px;\n}\n\n.registrationRequired {\n  flex: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"actions": `BDFIFHVM1uRktH456BNX`,
	"registrationRequired": `ty_WLxO50RmaYZjONQ5F`
};
export default ___CSS_LOADER_EXPORT___;
